import { Component, OnInit } from '@angular/core';
import {Publicite} from '../../../shared/components/models/publicite';
import {PubliciteService} from '../../../core/services/publicite.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-pub-d',
  templateUrl: './pub-d.component.html',
  styleUrls: ['./pub-d.component.scss']
})
export class PubDComponent implements OnInit {
  pubD: Publicite;
  publicites: Publicite[] = [];
  publiciteImageUri: string;
  constructor(private publiciteService: PubliciteService) {
    this.publiciteImageUri = environment.publiciteImageUri;
  }

  ngOnInit(): void {
    this.loadPublicite();
  }

  loadPublicite() {
    this.publiciteService.findPubD().subscribe(ret => {
      if (ret['status'] === 'OK') {
        this.publicites = ret['response'];
        // console.log(this.publicites);
        this.pubD = this.publicites.find(p=>p.type==='D');
      } else {
        // console.log('erreur survenu');
      }
    }, error => {
      // console.log('erreur server');
    });
  }
}
